var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"visibility-ind",class:{ faint: _vm.faint }},[_c('PossibleLink',{attrs:{"route":_vm.faint ? { name: 'ProfileSettings' } : undefined}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: _vm.visible ? 'eye' : 'eye-slash' }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }